import {Component, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {DistributorContract} from '../../models/distributor-contract';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from 'primeng/components/common/messageservice';
import {Tier} from '../../models/tier';
import {ConfirmationService} from 'primeng/components/common/api';
import {environment} from '../../../environments/environment';
import {DistributorContractArea} from '../../models/distributor-contract-area';
import {DistributorContractsService} from '../services/distributor-contracts.service';
import {Distributor} from '../../models/distributor';
import {BreadcrumbService} from '../../breadcrumb/breadcrumb.service';
import {GroupRight} from '../../models/group-right';
import {GroupRightService} from '../../services/group-right.service';

@Component({
	selector: 'app-distributor-contract-detail',
	templateUrl: './distributor-contract-detail.component.html'
})
export class DistributorContractDetailComponent implements OnInit
{
	public distributorContract: DistributorContract;
	public isNew: boolean;

	public tiers: Tier[];
	public distributorId: number;

	public groupRight: GroupRight = null;

	private contractFile: File;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private breadcrumbService: BreadcrumbService,
		private distributorContractsService: DistributorContractsService,
		private groupRightService: GroupRightService,
	)
	{
	}

	ngOnInit()
	{
		if (this.route.snapshot.data['groupRights'] instanceof Array) {
			this.groupRight = this.groupRightService.getGroupRightForModule('distributor', this.route.snapshot.data['groupRights'])
		}

		this.distributorId = this.route.snapshot.params['distributorId'];

		const contractData: any = this.route.snapshot.data['distributorContract'];

		if (this.route.snapshot.data['groupRights'] instanceof Array && !(this.route.snapshot.data['groupRights'] instanceof Response)) {
			let access = this.route.snapshot.data['groupRights'].filter(function (element, index, array) {
				return element.module_code === 'distributor';
			});
			this.groupRight = access[0]
		}

		if (contractData instanceof Object && !(contractData instanceof Response))
		{
			// DistributorContract was received.
			this.distributorContract = contractData;
			this.breadcrumbService.addBreadcrumbTranslation('Verspreider Bewerken', this.distributorContract.distributor.name);
			this.isNew = false;
		}
		else
		{
			// We are creating a new DistributorContract, or something went wrong.
			this.distributorContract = new DistributorContract();
			this.distributorContract.distributor = new Distributor();
			this.distributorContract.distributor.id = this.distributorId;
			this.isNew = true;

			if (contractData instanceof Response)
			{
				// We got a unhandled exception, let's show a message.
				this.messageService.add({
					severity: 'error',
					summary: 'Fout',
					detail: 'Er is een fout opgetreden tijdens het ophalen van het contract.'
				});
			}
		}

		const tiersData: any = this.route.snapshot.data['tiers'];

		if (tiersData instanceof Array)
		{
			this.tiers = tiersData;
		}
		else if (tiersData instanceof Response)
		{
			this.tiers = [];
			// We got a unhandled exception, let's show a message.
			this.messageService.add({
				severity: 'error',
				summary: 'Fout',
				detail: 'Er is een fout opgetreden tijdens het ophalen van de staffels.'
			});
		}

		this.tiers.forEach((tier: Tier) =>
		{
			if (this.distributorContract.tier !== null && this.distributorContract.tier.id === tier.id)
			{
				this.distributorContract.tier = tier;
			}
		});
	}

	public hasUserAccess(action: string)
	{
		return this.groupRight && this.groupRight[action];
	}

	public onFileSelect(event)
	{
		const files = event.target.files;

		if (files.length > 0) {
			this.contractFile = files[0];
		}
	}

	public goBack()
	{
		this.router.navigate(['/verspreiders/' + this.distributorContract.distributor.id]);
	}

	public saveContract()
	{
		let promise: Promise<DistributorContract>;
		if (this.isNew)
		{
			promise = this.distributorContractsService.storeDistributorContract(this.distributorContract, this.contractFile);

			promise.then((data) =>
			{
				if (data instanceof Response)
				{
					if (data.status === 422)
					{
						const shownMessages: Array<string> = [];
						const message: Object = data.json().message;

						Object.keys(message).forEach((fieldName) =>
						{
							message[fieldName].forEach((message) =>
							{
								if (shownMessages.indexOf(message) === -1)
								{
									shownMessages.push(message);

									this.messageService.add({
										severity: 'warning',
										summary: 'Validatiefout',
										detail: environment.validation.distributor_contract[message]
									});
								}
							});
						});
					}
					else
					{
						this.messageService.add({
							severity: 'error',
							summary: 'Contract niet opgeslagen',
							detail: 'Er is een fout opgetreden tijdens het opslaan van het contract.'
						});
					}
				}
				else
				{
					this.messageService.add({
						severity: 'success',
						summary: 'Contract opgeslagen',
						detail: 'Het contract is opgeslagen.'
					});

					this.router.navigate(['/verspreiders/' + data.distributor.id + '/contracten/' + data.id]);
				}
			});
		}
		else
		{
			this.confirmationService.confirm({
				message: 'Weet u zeker dat u dit contract wilt opslaan? Bij wijzigingen in het tabblad prijsberekening wordt de historie overschreven.',
				header: 'Contract opslaan?',
				icon: 'fa fa-save',
				accept: () =>
				{
					promise = this.distributorContractsService.updateDistributorContract(this.distributorContract);

					promise.then((data) =>
					{
						if (data instanceof Response)
						{
							if (data.status === 422)
							{
								const shownMessages: Array<string> = [];
								const message: Object = data.json().message;

								Object.keys(message).forEach((fieldName) =>
								{
									message[fieldName].forEach((message) =>
									{
										if (shownMessages.indexOf(message) === -1)
										{
											shownMessages.push(message);

											this.messageService.add({
												severity: 'warning',
												summary: 'Validatiefout',
												detail: environment.validation.distributor_contract[message]
											});
										}
									});
								});
							}
							else
							{
								this.messageService.add({
									severity: 'error',
									summary: 'Contract niet opgeslagen',
									detail: 'Er is een fout opgetreden tijdens het opslaan van het contract.'
								});
							}
						}
						else
						{
							this.messageService.add({
								severity: 'success',
								summary: 'Contract opgeslagen',
								detail: 'Het contract is opgeslagen.'
							});

							this.router.navigate(['/verspreiders/' + data.distributor.id + '/contracten/' + data.id]);
						}
					});
				}
			});
		}
	}

	public removeContract()
	{
		this.confirmationService.confirm({
			message: 'Weet u zeker dat u dit contract wilt verwijderen?',
			header: 'Contract verwijderen?',
			icon: 'fa fa-trash',
			accept: () =>
			{
				this.distributorContractsService.removeDistributorContract(this.distributorContract.id)
					.then((data) =>
					{
						this.messageService.add({
							severity: 'success',
							summary: 'Contract verwijderd',
							detail: 'Het contract is verwijderd.'
						});

						this.router.navigate(['/verspreiders/' + this.distributorContract.distributor.id]);
					})
					.catch((data) =>
					{
						this.messageService.add({
							severity: 'error',
							summary: 'Contract niet verwijderd',
							detail: 'Het contract kon niet worden verwijderd.'
						});
					});
			}
		});
	}

	public createArea()
	{
		this.router.navigate(['/verspreiders/' + this.distributorId + '/contracten/' + this.distributorContract.id + '/gebieden/aanmaken']);
	}

	public exportArea(area: DistributorContractArea)
	{
		let csvContent = "data:text/csv;charset=utf-8,";
		csvContent += "Postcode;Plaats;Omschrijving;Opt-In;Prijs 0/00;Brievenbussen;Kranten aantal;Folder aantal;Loopdag;Product;\r\n"

		area.distributorContractAreaPostcodes.forEach(function( obj ) {

		    csvContent += obj.postcode.postcode+";"+
				obj.postcode.city+";"+
				obj.postcode.description+";"+
				(obj.optin ? "Ja" : "Nee")+";"+
				(obj.price_per_thousand != null ? obj.price_per_thousand : "")+";"+
				obj.total_amount+";" +
				obj.gross_amount+";"+
				obj.net_amount+";"+
				obj.walkday+";"+
				(obj.distributorProduct !== undefined ? obj.distributorProduct.name : "")+";"+
				"\r\n";
		});

		var encodedUri = encodeURI(csvContent);
		var link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		link.setAttribute("download", "verspreidgebied-export.csv");
		document.body.appendChild(link);
		link.click();
	}

	public openArea(area: DistributorContractArea)
	{
		this.router.navigate(['/verspreiders/' + this.distributorId + '/contracten/' + this.distributorContract.id + '/gebieden/' + area.id]);
	}

	public uploadContractFile(distributorContract: DistributorContract, file: File)
	{
		if (file) {
			this.distributorContractsService.uploadContractFile(distributorContract, file).subscribe(
				data => {
					this.messageService.add({
						severity: 'success',
						summary: 'Bestand geüpload',
						detail: 'Het contract bestand is geüpload'
					});

					this.distributorContract = data['data'] as DistributorContract;
				},
				err => {
					this.messageService.add({
						severity: 'error',
						summary: 'Bestand niet geüpload',
						detail: 'Er is een fout opgrtreden bij het uploaden van het bestand'
					});
				}
			);
		}
	}

	public deleteContractFile(distributorContract: DistributorContract)
	{
		this.distributorContractsService.deleteContractFile(distributorContract).subscribe(
			data => {
				this.distributorContract = data;

				this.messageService.add({
					severity: 'success',
					summary: 'Bestand verwijderd',
					detail: 'Het contract PDF bestand is verwijderd'
				});
			},
			err => {
				this.messageService.add({
					severity: 'error',
					summary: 'Bestand niet verwijderd',
					detail: 'Het bestand kon niet worden verwijderd'
				})
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/distributor-contract-detail/distributor-contract-detail.component.ts